import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { FormArray, FormGroup } from '@angular/forms';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Location } from '@angular/common';
import { CandidateAttendanceService } from 'projects/services/src/app/API/candidate-attendance.service';

@Component({
  selector: 'app-pmkvy-bio-metric-attendance',
  templateUrl: './pmkvy-bio-metric-attendance.component.html',
  styleUrls: ['./pmkvy-bio-metric-attendance.component.css']
})
export class PmkvyBioMetricAttendanceComponent implements OnInit {
  batchId: any;
  pageNo: Number = 1;
  count = 0;
  tabType: string = ''
  itemPerPage: Number = 10;
  attendanceData: any = [];
  headerDate: any;
  // statusColor = {
  //   'A': '#D73D31',
  //   'P': '#A5D300',
  // };
  modelObj: any = {
    attendenceStatus: '',
    candidateId: '',
  };
  statusColor = {
    'A': '#D73D31',
    'P': '#A5D300',
    'Completed': '#417505',
    'Dropout': '#D0021B',
    'Lateral': '#F5A623'


  };


  monthArray: any = [{
    'name': 'January',
    'value': 1
  },
  {
    'name': 'February',
    'value': 2
  },
  {
    'name': 'March',
    'value': 3
  },
  {
    'name': 'April',
    'value': 4
  },
  {
    'name': 'May',
    'value': 5
  },
  {
    'name': 'June',
    'value': 6
  },
  {
    'name': 'July',
    'value': 7
  },
  {
    'name': 'August',
    'value': 8
  },
  {
    'name': 'September',
    'value': 9
  },
  {
    'name': 'October',
    'value': 10
  },
  {
    'name': 'November',
    'value': 11
  },
  {
    'name': 'December',
    'value': 12
  }
  ]

  dates: any;
  items: FormArray;
  jobRole: any;
  nonFormatDate: any;
  batchStartDate: any;
  candidateArray: any = [];
  dataHeader: any = []
  dateArray: any = [];
  nonFormatBatchEndDate: any;
  tableHeaderData: any = [];
  attendenceByDate: any = [];
  batchAttendenceArray: any = [];
  showTable: boolean;
  supportingDoc: any;
  monthFilter: FormGroup;
  todayDateValue = new Date();
  holidayDate: any;
  maxArraySize: any = [];
  indexHighArraySize: number;
  dateArrya: any = [];
  dropArray: any;
  totalArraySize: any;
  schemeName: any;
  stateCode: any;
  subScheme: any;
  trainingType: any;
  batchData: any = {};
  currentCandidate: any = {};
  constructor(
    private activatedRoute: ActivatedRoute,
    private batchService: BatchService,
    private candidateAttendanceService: CandidateAttendanceService,
    private location: Location
  ) {

  }


  ngOnInit() {
    this.activatedRoute.parent.data.subscribe(data => {
      console.log(data, 'change data batch');
      if (data && data.batch && data.batch.schemeName) {
        this.schemeName = data.batch.schemeName;
      }
      if (data &&
        data.batch &&
        data.batch.address
        && data.batch.address.state
        && data.batch.address.state.id) {
        this.stateCode = data.batch.address.state.id;
      }
      if (data.batch && data.batch.batchId) {
        this.batchId = data.batch.batchId;
      } else {
        this.activatedRoute.params.subscribe(data => {
          this.batchId = data.batchId;
        })
      }
    })
    this.batchService.getFeeBasedBatchDetails(this.batchId).subscribe(res => {
      this.batchData = res;
    })

    this.subScheme = this.activatedRoute.snapshot.queryParams.subScheme;
    this.trainingType = this.activatedRoute.snapshot.queryParams.trainingType;

    if (this.schemeName === undefined || this.stateCode === undefined) {
      this.activatedRoute.data.subscribe(data => {
        if (data && data.batch && data.batch.schemeName) {
          this.schemeName = data.batch.schemeName;
        }
        if (data &&
          data.batch &&
          data.batch.address
          && data.batch.address.state
          && data.batch.address.state.id) {
          this.stateCode = data.batch.address.state.id;
        }
        if (data.batch && data.batch.batchId) {
          this.batchId = data.batch.batchId;
        } else {
          this.activatedRoute.params.subscribe(data => {
            this.batchId = data.batchId;
          })
        }
      })
    }

    this.setTab('candidate');
    // this.getBioMetricAttendance()
    this.getAllAttendenceForBatch()

  }

  setTab(tab) {
    if (tab === 'candidate') {
      this.tabType = 'candidate'
      this.getAllAttendenceForBatch();
    } else if (tab === 'batch') {
      this.tabType = 'batch'
      this.getBioMetricAttendanceForBatch();
    }
  }

  getBioMetricAttendanceForBatch(filterObj?) {
    this.attendanceData = [];
    let isCssm;
    let isSkillHub;
    let isNipun;
    let isMohuaAebase;
    if (this.schemeName === 'PMKVY-CSSM') {
      isCssm = 'yes';
    } else {
      isCssm = 'no'
    }
    if (this.subScheme == 10 && this.schemeName !== 'PMKVY-4.0-CSCM') {
      isSkillHub = 'yes';
    } else {
      isSkillHub = 'no';
    }
    if (this.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs' && this.trainingType === 'RPL') {
      isNipun = 'yes';
    } else if (this.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs' && (this.trainingType === 'SP' || this.trainingType === 'ST')) {
      isMohuaAebase = 'yes';
    }
    this.batchService.getBioMetricAttendance(this.pageNo, this.itemPerPage, this.batchId, 'batch', isCssm, this.stateCode, filterObj, '', isSkillHub, isNipun, '', '', isMohuaAebase).subscribe(res => {
      console.log(res);
      this.count = res.pagination.count;
      if (res.data) {
        this.attendanceData = res.data;
        // this.headerDate = res.data;
        console.log(this.headerDate);

      }
    })
  }



  assignPageNo(data) {
    this.pageNo = data;
    // this.getBioMetricAttendance();
    if (this.tabType === 'candidate') {
      this.getAllAttendenceForBatch();
    } else if (this.tabType === 'batch') {
      this.getBioMetricAttendanceForBatch();
    }
  }

  assignRecordsPerPage(data) {
    this.itemPerPage = data;
    // this.getBioMetricAttendance();
    if (this.tabType === 'candidate') {
      this.getAllAttendenceForBatch();
    } else if (this.tabType === 'batch') {
      this.getBioMetricAttendanceForBatch();
    }
  }

  applyFilter() {
    if (this.tabType === 'candidate') {
      this.getAllAttendenceForBatch(this.modelObj);
    } else if (this.tabType === 'batch') {
      this.getBioMetricAttendanceForBatch(this.modelObj);
    }
  }

  reset() {
    this.modelObj.candidateId = '';
    this.modelObj.attendenceStatus = '';
    if (this.tabType === 'candidate') {
      this.getAllAttendenceForBatch();
    } else if (this.tabType === 'batch') {
      this.getAllAttendenceForBatch();
    }
  }

  getData(data) {
    if (data.totalPresentCount === 0.0) {
      return 0
    } else {
      return data.totalPresentCount;
    }
  }

  getAllAttendenceForBatch(filterObj?) {
    let isCssm;
    let isSkillHub;
    let isNipun;
    let isMohuaAebase;
    if (this.schemeName === 'PMKVY-CSSM') {
      isCssm = 'yes';
    } else {
      isCssm = 'no'
    }
    if (this.subScheme == 10 && this.schemeName !== 'PMKVY-4.0-CSCM') {
      isSkillHub = 'yes';
    } else {
      isSkillHub = 'no';
    }
    if (this.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs' && this.trainingType === 'RPL') {
      isNipun = 'yes';
    } else if (this.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs' && (this.trainingType === 'SP' || this.trainingType === 'ST')) {
      isMohuaAebase = 'yes';
    }
    this.candidateAttendanceService.getAebaseAttendance(this.batchId, isCssm, this.stateCode, filterObj, isSkillHub, isNipun, isMohuaAebase).subscribe(res => {
      console.log(res);
      if (res.data && res.data.length > 0) {
        Helpers.copyArray(this.tableHeaderData, res.data[0].date)
        const elements = (res.data) || [];
        const mapElements = elements.map(element => ({
          'candiateName': element.candidateName,
          'candidateId': element.candidateId,
          'supportingDocs': element.supportingDocs,
          'attendence': element.attendence,
          'status': element.status,
          'percentage': '0'
        }));

        this.batchAttendenceArray = mapElements;
        this.dateArray = [];
        for (let index = 0; index < this.batchAttendenceArray.length; index++) {
          if (this.batchAttendenceArray[index].status === 'Enroll') {
            this.dateArray.push(this.batchAttendenceArray[index]);
            this.totalArraySize = this.batchAttendenceArray[index].attendence.length;
          }
          if (this.batchData && this.batchData.schemeType == 'RPL') {
            /* 
             attendance calculation validation changes based on scheme type rpl ------>>>
              */
            if (this.batchAttendenceArray && this.batchAttendenceArray[index].attendence && this.batchAttendenceArray[index].attendence.length) {
              let totalEligibleCandidateHours = 0;
              for (let i = 0; i < this.batchAttendenceArray[index].attendence.length; i++) {
                if (this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration <= 0) {
                  this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration = 0;
                }
                if (this.batchAttendenceArray[index].attendence && this.batchAttendenceArray[index].attendence[i]) {
                  totalEligibleCandidateHours = totalEligibleCandidateHours + (this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration ? this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration : 0);
                }
              }
              totalEligibleCandidateHours = Number(Number(totalEligibleCandidateHours).toFixed(2));
              if (totalEligibleCandidateHours > this.batchData.totalNoOfTrainingHrs) {
                this.batchAttendenceArray[index]['totalEligibleCandidateHours'] = this.batchData.totalNoOfTrainingHrs;
              } else if (totalEligibleCandidateHours == 0 || totalEligibleCandidateHours <= this.batchData.totalNoOfTrainingHrs) {
                this.batchAttendenceArray[index]['totalEligibleCandidateHours'] = totalEligibleCandidateHours;
              }
              let totalEligibleCandidateHoursPercentage = 0;
              totalEligibleCandidateHoursPercentage = (totalEligibleCandidateHours / this.batchData.totalNoOfTrainingHrs) * 100;
              totalEligibleCandidateHoursPercentage = Number(Number(totalEligibleCandidateHoursPercentage).toFixed(2));

              if (totalEligibleCandidateHoursPercentage >= 69.50 && totalEligibleCandidateHoursPercentage <= 70) {
                totalEligibleCandidateHoursPercentage = 70.00;
              }
              this.batchAttendenceArray[index]['totalEligibleCandidateHoursPercentage'] = totalEligibleCandidateHoursPercentage;
              /* 
              changes for the hourly based attendace end
              */
            }
          } else {
            /* 
             attendance calculation validation changes based on scheme type other than rpl ------>>>
              */
            if (this.batchAttendenceArray && this.batchAttendenceArray[index].attendence && this.batchAttendenceArray[index].attendence.length) {
              let totalEligibleCandidateHours = 0;
              for (let i = 0; i < this.batchAttendenceArray[index].attendence.length; i++) {
                if (this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration <= 0) {
                  this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration = 0;
                }
                if (this.batchAttendenceArray[index].attendence && this.batchAttendenceArray[index].attendence[i]) {
                  totalEligibleCandidateHours = totalEligibleCandidateHours + (this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration ? this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration : 0);
                }
              }
              totalEligibleCandidateHours = Number(Number(totalEligibleCandidateHours).toFixed(2));
              if (totalEligibleCandidateHours > this.batchData.jobRoles[0].overrideQpHours) {
                this.batchAttendenceArray[index]['totalEligibleCandidateHours'] = this.batchData.jobRoles[0].overrideQpHours;
              } else if (totalEligibleCandidateHours == 0 || totalEligibleCandidateHours <= this.batchData.jobRoles[0].overrideQpHours) {
                this.batchAttendenceArray[index]['totalEligibleCandidateHours'] = totalEligibleCandidateHours;
              }
              let totalEligibleCandidateHoursPercentage = 0;
              totalEligibleCandidateHoursPercentage = (totalEligibleCandidateHours / this.batchData.jobRoles[0].overrideQpHours) * 100;
              totalEligibleCandidateHoursPercentage = Number(Number(totalEligibleCandidateHoursPercentage).toFixed(2));

              if (totalEligibleCandidateHoursPercentage >= 69.50 && totalEligibleCandidateHoursPercentage <= 70) {
                totalEligibleCandidateHoursPercentage = 70.00;
              }
              this.batchAttendenceArray[index]['totalEligibleCandidateHoursPercentage'] = totalEligibleCandidateHoursPercentage;

            }

          }
          /* 
                 attendance calculation validation changes from overrideQpHours to totalNoOfTrainingHrs ------>>>
                 
                 
      
                if (this.batchAttendenceArray && this.batchAttendenceArray[index].attendence && this.batchAttendenceArray[index].attendence.length) {
                  let totalEligibleCandidateHours = 0;
                  for (let i = 0; i < this.batchAttendenceArray[index].attendence.length; i++) {
                    if (this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration <= 0) {
                      this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration = 0;
                    }
                    if (this.batchAttendenceArray[index].attendence && this.batchAttendenceArray[index].attendence[i]) {
                      totalEligibleCandidateHours = totalEligibleCandidateHours + (this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration ? this.batchAttendenceArray[index].attendence[i].eligibleCandidatePerDayDuration : 0);
                    }
                  }
                  totalEligibleCandidateHours = Number(Number(totalEligibleCandidateHours).toFixed(2));
                  if (totalEligibleCandidateHours > this.batchData.jobRoles[0].overrideQpHours) {
                    this.batchAttendenceArray[index]['totalEligibleCandidateHours'] = this.batchData.jobRoles[0].overrideQpHours;
                  } else if (totalEligibleCandidateHours == 0 || totalEligibleCandidateHours <= this.batchData.jobRoles[0].overrideQpHours) {
                    this.batchAttendenceArray[index]['totalEligibleCandidateHours'] = totalEligibleCandidateHours;
                  }
                  let totalEligibleCandidateHoursPercentage = 0;
                  totalEligibleCandidateHoursPercentage = (totalEligibleCandidateHours / this.batchData.jobRoles[0].overrideQpHours) * 100;
                  totalEligibleCandidateHoursPercentage = Number(Number(totalEligibleCandidateHoursPercentage).toFixed(2));
      
                  if (totalEligibleCandidateHoursPercentage >= 69.50 && totalEligibleCandidateHoursPercentage <= 70) {
                    totalEligibleCandidateHoursPercentage = 70.00;
                  }
                  this.batchAttendenceArray[index]['totalEligibleCandidateHoursPercentage'] = totalEligibleCandidateHoursPercentage;
                  
                }
                  */



        }


        for (let index = 0; index < this.batchAttendenceArray.length; index++) {
          if (this.batchAttendenceArray[index].supportingDocs) {
            this.supportingDoc = this.batchAttendenceArray[0].supportingDocs
          }
        }
      } else {
        this.batchAttendenceArray = [];

      }
      if (this.dateArray.length !== 0) {
        this.addMissingAttendace()
      }

    })

  }

  addMissingAttendace() {
    for (let index = 0; index < this.batchAttendenceArray.length; index++) {
      if (this.batchAttendenceArray[index].attendence.length !== this.totalArraySize) {
        let totalNumberIteration = this.totalArraySize - this.batchAttendenceArray[index].attendence.length;
        for (let idx = 0; idx < totalNumberIteration; idx++) {
          // this.batchAttendenceArray[index].attendence[idx].unshift()
          this.batchAttendenceArray[index].attendence.unshift({ 'attendenceStatus': 'N/A' })
        }
      }
    }
  }


  goBack() {
    this.location.back()
  }

  openAttendanceModal(data?) {
    this.currentCandidate = data;
    Helpers.openModal('candidate-attendance');
  }
  closeAttendanceModal() {
    Helpers.closeModal('candidate-attendance');
    this.currentCandidate = {};
  }

}
